import io from "socket.io-client";
import api from "../services/api";


class SocketWorker {
  constructor(companyId , userId) {
    const sessionToken = api.defaults.headers.Authorization

    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = sessionToken
      this.socket = null;
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados (antes de conectar: o "connect" usa)
      this.configureSocket();
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      // transports: ["websocket", "polling", "flashsocket"],
      // pingTimeout: 18000,
      // pingInterval: 18000,
      query: { userId: this.userId, token: this.token }
    });

    // Reconexão sempre com o token ATUAL: o token do login é renovado (expira em 8h) e o
    // socket guardava o da criação — depois de vencido, toda reconexão era recusada pelo
    // servidor e a tela ficava sem tempo real até atualizar a página.
    this.socket.io.on("reconnect_attempt", () => {
      this.socket.io.opts.query = { userId: this.userId, token: this.currentToken() };
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
      // socket.io-client v4: "reconnect" é evento do Manager, não do socket — quem fazia
      // socket.on("reconnect", ...) (ex.: MessagesList recarregar o que perdeu) nunca era
      // avisado. Repassa a esses ouvintes em toda conexão depois da primeira.
      if (this.hadConnection) this.notifyListeners("reconnect");
      this.hadConnection = true;
      this.serverDisconnects = 0;
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Desconectado do servidor Socket.IO:", reason);
      // Quando é o SERVIDOR que derruba (ex.: token vencido), o socket.io não tenta de novo
      // sozinho — renova o token e reconecta.
      if (reason === "io server disconnect") this.reconnectWithFreshToken();
    });
  }

  currentToken() {
    return api.defaults.headers.Authorization || this.token;
  }

  notifyListeners(event) {
    (this.eventListeners[event] || []).forEach((cb) => {
      try {
        cb();
      } catch (err) {
        console.warn(`[SocketWorker] ouvinte de '${event}' falhou`, err);
      }
    });
  }

  async reconnectWithFreshToken() {
    this.serverDisconnects = (this.serverDisconnects || 0) + 1;
    const delay = Math.min(30000, 1000 * 2 ** Math.min(this.serverDisconnects, 5));
    try {
      // chamada leve autenticada: se o token venceu, o interceptor do useAuth faz o
      // refresh (/auth/refresh_token) do jeito dele, sem disputar com outras chamadas
      if (this.userId) await api.get(`/users/${this.userId}`);
    } catch (_) {
      /* o próprio interceptor trata 401/logout */
    }
    setTimeout(() => {
      if (!this.socket || this.socket.connected) return;
      this.socket.io.opts.query = { userId: this.userId, token: this.currentToken() };
      this.socket.connect();
    }, delay);
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    if (!this.socket) {
      this.connect();
    }
    
    if (!this.socket || typeof this.socket.on !== 'function') {
      console.warn(`[SocketWorker] Tentativa de registrar listener '${event}' com socket não disponível`);
      return;
    }
    
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    if (!this.socket) {
      this.connect();
    }
    
    if (!this.socket || typeof this.socket.emit !== 'function') {
      console.warn(`[SocketWorker] Tentativa de emitir evento '${event}' com socket não disponível`);
      return;
    }
    
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    if (!this.socket) {
      return;
    }
    
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      this.instance = null
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;